import { render } from "./App.vue?vue&type=template&id=7cffdd19"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7cffdd19&lang=less"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__